import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.category}}
  <div class="category-status" aria-hidden="true">
    {{#if this.hasParentCategory}}
      {{#unless this.hideParentCategory}}
        {{this.badgeForParentCategory}}
      {{/unless}}
    {{/if}}
    {{this.badgeForCategory}}
  </div>

  {{#if this.shouldDisplayDescription}}
    <div class="category-desc" aria-hidden="true">{{dir-span
        this.descriptionText
        htmlSafe="true"
      }}</div>
  {{/if}}
{{else}}
  {{html-safe this.label}}
{{/if}}
*/
{
  "id": "kI44d7pG",
  "block": "[[[41,[30,0,[\"category\"]],[[[1,\"  \"],[10,0],[14,0,\"category-status\"],[14,\"aria-hidden\",\"true\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasParentCategory\"]],[[[41,[51,[30,0,[\"hideParentCategory\"]]],[[[1,\"        \"],[1,[30,0,[\"badgeForParentCategory\"]]],[1,\"\\n\"]],[]],null]],[]],null],[1,\"    \"],[1,[30,0,[\"badgeForCategory\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"shouldDisplayDescription\"]],[[[1,\"    \"],[10,0],[14,0,\"category-desc\"],[14,\"aria-hidden\",\"true\"],[12],[1,[28,[35,2],[[30,0,[\"descriptionText\"]]],[[\"htmlSafe\"],[\"true\"]]]],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"  \"],[1,[28,[35,3],[[30,0,[\"label\"]]],null]],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"unless\",\"dir-span\",\"html-safe\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/none-category-row.hbs",
  "isStrictMode": false
});